const cubicBezier = (x1: number, y1: number, x2: number, y2: number) => {
  return (time: number) => {
    if (time <= 0) {
      return 0
    }

    if (time >= 1) {
      return 1
    }

    let start = 0
    let end = 1

    for (let index = 0; index < 8; index += 1) {
      const middle = (start + end) / 2
      const x =
        3 * (1 - middle) * (1 - middle) * middle * x1 +
        3 * (1 - middle) * middle * middle * x2 +
        middle * middle * middle

      if (x < time) {
        start = middle
      } else {
        end = middle
      }
    }

    const t = (start + end) / 2
    return 3 * (1 - t) * (1 - t) * t * y1 + 3 * (1 - t) * t * t * y2 + t * t * t
  }
}

const bounceOut = (time: number) => {
  if (time < 1 / 2.75) {
    return 7.5625 * time * time
  }

  if (time < 2 / 2.75) {
    const next = time - 1.5 / 2.75
    return 7.5625 * next * next + 0.75
  }

  if (time < 2.5 / 2.75) {
    const next = time - 2.25 / 2.75
    return 7.5625 * next * next + 0.9375
  }

  const next = time - 2.625 / 2.75
  return 7.5625 * next * next + 0.984375
}

export const Easing = {
  linear: (time: number) => time,
  ease: cubicBezier(0.25, 0.1, 0.25, 1),
  quad: (time: number) => time * time,
  cubic: (time: number) => time * time * time,
  poly: (power: number) => (time: number) => time ** power,
  sin: (time: number) => 1 - Math.cos((time * Math.PI) / 2),
  circle: (time: number) => 1 - Math.sqrt(1 - time * time),
  exp: (time: number) => (time === 0 ? 0 : 2 ** (10 * (time - 1))),
  elastic:
    (bounciness = 1) =>
    (time: number) => {
      if (time === 0 || time === 1) {
        return time
      }

      return 1 - Math.cos((time * Math.PI) / 2) ** 3 * Math.cos(time * bounciness * Math.PI)
    },
  back:
    (overshoot = 1.70158) =>
    (time: number) =>
      time * time * ((overshoot + 1) * time - overshoot),
  bounce: (time: number) => 1 - bounceOut(1 - time),
  bezier: cubicBezier,
  in: (easing: (time: number) => number) => easing,
  out: (easing: (time: number) => number) => (time: number) => 1 - easing(1 - time),
  inOut: (easing: (time: number) => number) => (time: number) =>
    time < 0.5 ? easing(time * 2) / 2 : 1 - easing((1 - time) * 2) / 2,
}
